import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  performanceLoading: false,
  creatorsList: [],
  consolidatedTotal: {},
  total: 0,
  size: 0,
  totalPages: 0,
  page: 0,
  loaderForButton: false,
};
const PerformanceSlice = createSlice({
  name: "performance",
  initialState,
  reducers: {
    setPerformanceLoading(state, action) {
      state.performanceLoading = action?.payload;
    },
    setCreatorsList(state, action) {
      state.creatorsList = action?.payload?.pagination
        ? [...state.creatorsList, ...action?.payload?.creatorsList]
        : action?.payload?.creatorsList;
      state.consolidatedTotal = action?.payload?.consolidatedTotal;
      state.total = action?.payload?.total;
      state.totalPages = action?.payload?.totalPages;
      state.page = action?.payload?.page;
      state.size = action?.payload?.size;
      state.loaderForButton = action?.payload?.loaderForButton;
      state.performanceLoading = action?.payload?.performanceLoading;
    },
    setLoaderForButton(state, action) {
      state.loaderForButton = action?.payload;
    },
    clearPerformance(action, state) {
      return initialState;
    },
  },
});

export const performanceActions = PerformanceSlice.actions;

export default PerformanceSlice;
